import * as React from 'react';
import axios from 'axios';
import { Alert, Button, Container, Grid2, TextField, Typography } from '@mui/material';
import { useSelector } from 'react-redux';
import Navbar from '../setup/Navbar';
import '../../services/GlobalVariables';

const API_URL = global.SET_API_URL + 'users/';

export default function CreateUser() {
  const { user } = useSelector((state) => state.auth);

  const [formData, setFormData] = React.useState({
    dispName: '',
    userName: '',
    userPassword: ''
  });
  const [isSaving, setIsSaving] = React.useState(false);
  const [successMsg, setSuccessMsg] = React.useState('');
  const [errorMsg, setErrorMsg] = React.useState('');

  const onChange = (e) => {
    setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    setSuccessMsg('');
    setErrorMsg('');

    if (!formData.dispName || !formData.userName || !formData.userPassword) {
      setErrorMsg('Please fill all fields.');
      return;
    }

    if (!user?.cmpID) {
      setErrorMsg('Company context missing. Please login again.');
      return;
    }

    try {
      setIsSaving(true);
      const payload = {
        cmpID: user.cmpID,
        dispName: formData.dispName,
        userName: formData.userName,
        userPassword: formData.userPassword
      };

      await axios.post(API_URL + 'addNewUser', payload);

      setSuccessMsg('User created successfully.');
      setFormData({
        dispName: '',
        userName: '',
        userPassword: ''
      });
    } catch (error) {
      const message =
        (error.response && error.response.data && error.response.data.message) ||
        error.message ||
        'Failed to create user.';
      setErrorMsg(message);
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <>
      <Navbar />
      <Container maxWidth="sm" sx={{ mt: 3 }}>
        <Typography variant="h5" sx={{ mb: 2 }}>
          Create User
        </Typography>
        <Typography variant="body2" sx={{ mb: 3, color: 'text.secondary' }}>
          Create a secondary user for your company.
        </Typography>

        {successMsg ? <Alert severity="success" sx={{ mb: 2 }}>{successMsg}</Alert> : null}
        {errorMsg ? <Alert severity="error" sx={{ mb: 2 }}>{errorMsg}</Alert> : null}

        <Grid2 container spacing={2} component="form" onSubmit={onSubmit}>
          <Grid2 size={12}>
            <TextField
              label="Display Name"
              name="dispName"
              value={formData.dispName}
              onChange={onChange}
              fullWidth
              required
            />
          </Grid2>
          <Grid2 size={12}>
            <TextField
              label="User Name"
              name="userName"
              value={formData.userName}
              onChange={onChange}
              fullWidth
              required
            />
          </Grid2>
          <Grid2 size={12}>
            <TextField
              label="Password"
              name="userPassword"
              type="password"
              value={formData.userPassword}
              onChange={onChange}
              fullWidth
              required
            />
          </Grid2>
          <Grid2 size={12}>
            <Button type="submit" variant="contained" disabled={isSaving} fullWidth>
              {isSaving ? 'Creating...' : 'Create User'}
            </Button>
          </Grid2>
        </Grid2>
      </Container>
    </>
  );
}
